export let new_GroupButton = "m5qIw";
export let delete_GroupButton = "fuT$sc";
export let moveAndDelete_GroupButton = "bddzbe";
export let respond_GroupButton = "FC_cyd";
export let tags_GroupButton = "Xx5Rce";
export let send_GroupButton = "KX01wd";
export let sync_GroupButton = "zoFXcb";
export let download_GroupButton = "E60WWb";
export let move_GroupButton = "TXvAxe";
export let find_GroupButton = "D1N5Rd";
export let addIns_GroupButton = "ZsH8qc";
export let immersiveReader_GroupButton = "y0VEac";
export let window_GroupButton = "iNgypb";
export let print_GroupButton = "L31lee";
export let undo_GroupButton = "QchBMe";
export let clipboard_Group = "EuJw2c";
export let include_Group = "yieYqd";
export let encrypt_Group = "D8ICQ";
export let save_Group = "Rla0Eb";
export let sensitivity_Group = "vpekMe";
export let basicText_Group = "psYI8";
export let paragraph_Group = "aLtrTb";
export let notes_GroupNew = "XL_Gt";
export let notes_GroupEdit = "JCf_yd";
export let notes_GroupView = "_RPe3d";
export let table_GroupMerge = "wU$Hbd";
export let table_GroupAlignment = "vW1zId";
export let table_GroupTableStyles = "y$GWwd";
export let viewSettings_Group = "oh2uMe";
export let viewMessages_Group = "lzCWkb";
export let viewLayout_Group = "dI5NTb";
export let tags_Group = "ZjfxX";
export let actions_Group = "bQa32c";
export let findTime_GroupButton = "wt1cWd";
export let insert_Group = "dXtdw";
export let options_Group = "ckZOjc";
export let proofing_Group = "qfEj6d";
export let loop_Group = "uyEbKd";
export let format_Group = "rP953b";
export let showField_Group = "R7FZH";
export let tracking_Group = "jL0nNc";
export let quickSteps_Group = "ahUEec";
export let themes_Group = "A49Yd";
export let styling_Group = "qnQfGe";
export let draftWithCopilot_Group = "RxC3tc";
export let draw_Undo_Group = "lUJTSb";
export let draw_Selection_Group = "lPgISd";
export let draw_Tools_Group = "OKgjAd";
export let draw_Touch_Group = "eab3Dd";
export let draw_Insert_Group = "YZKP4";
export let voice_Group = "yNPcJb";
export let zoom_Group = "vTRmDe";
export let mailMerge_Group = "rOCyP";
export let mailMerge_Data_Group = "S6L38c";
export default {new_GroupButton,delete_GroupButton,moveAndDelete_GroupButton,respond_GroupButton,tags_GroupButton,send_GroupButton,sync_GroupButton,download_GroupButton,move_GroupButton,find_GroupButton,addIns_GroupButton,immersiveReader_GroupButton,window_GroupButton,print_GroupButton,undo_GroupButton,clipboard_Group,include_Group,encrypt_Group,save_Group,sensitivity_Group,basicText_Group,paragraph_Group,notes_GroupNew,notes_GroupEdit,notes_GroupView,table_GroupMerge,table_GroupAlignment,table_GroupTableStyles,viewSettings_Group,viewMessages_Group,viewLayout_Group,tags_Group,actions_Group,findTime_GroupButton,insert_Group,options_Group,proofing_Group,loop_Group,format_Group,showField_Group,tracking_Group,quickSteps_Group,themes_Group,styling_Group,draftWithCopilot_Group,draw_Undo_Group,draw_Selection_Group,draw_Tools_Group,draw_Touch_Group,draw_Insert_Group,voice_Group,zoom_Group,mailMerge_Group,mailMerge_Data_Group};